import React from 'react';
import _get from 'lodash/get';
import _isEqual from 'lodash/isEqual';
import { useFocused, useSelected } from 'slate-react';
import getCurrentSelection from './helpers/getCurrentSelection';
import makeStyles from '@material-ui/core/styles/makeStyles';
import LinkPopover from './LinkPopover';

const Link = ({ attributes, element, children, editor }: any) => {
  const classes = useStyles();
  const { selection } = editor;
  const selected = useSelected();
  const focused = useFocused();
  const linkText = _get(children, [0, 'props', 'parent', 'children', 0, 'text']);
  const { currentWord, currentRange } = getCurrentSelection(editor);
  const selectedWordIsPartOfLinkText = Boolean(currentWord) && linkText.includes(currentWord);
  const selectionPathIsTheSame =
    _isEqual(_get(selection, ['anchor', 'path']), _get(currentRange, ['anchor', 'path'])) &&
    _isEqual(_get(selection, ['focus', 'path']), _get(currentRange, ['focus', 'path']));
  const linkIsSelected = selectedWordIsPartOfLinkText && selectionPathIsTheSame;

  return (
    <span className={classes.root}>
      <a href={element.href} {...attributes} {...element.attr} className={classes.link}>
        {children}
      </a>
      {linkIsSelected && selected && focused && (
        <LinkPopover className={classes.linkPopup} href={element.href} editor={editor} />
      )}
    </span>
  );
};

const useStyles = makeStyles(theme => ({
  root: { position: 'relative' },
  linkPopup: {
    position: 'absolute',
    left: 0,
    display: 'flex',
    alignItems: 'center',
    backgroundColor: 'white',
    padding: 6,
    borderRadius: 6,
    border: `1px solid lightgray`,
    width: 'fit-content',
    zIndex: 1,
  },
  link: {
    color: theme.palette.secondary.main,
  },
}));

export default Link;
